import './StatusBadge.scss';
import React from 'react';
import { FlightTooltip } from '@flybits/design-system';

const CLASS_MAIN = 'status-badge';
const CLASSES = {
  HELP_CURSOR: `${CLASS_MAIN}--help`,
  ICON: `${CLASS_MAIN}__icon`,
};

export enum STATUS_TYPES {
  STATUS_VERIFIED = 'verified',
  STATUS_ACTIVE = 'active',
  STATUS_PENDING = 'pending',
  STATUS_FAILED = 'failed',
  STATUS_CANCELLED = 'cancelled',
  STATUS_ERROR = 'error',
  STATUS_DELETED = 'deleted',
  STATUS_DRAFT = 'draft',
  STATUS_PENDING_DELETION = 'pending-deletion',
  STATUS_INACTIVE = 'inactive',
  STATUS_EXPIRED = 'expired',
  STATUS_SCHEDULED = 'scheduled',
  STATUS_NEEDS_MAPPING = 'needs-mapping',
  STATUS_MANUAL_EDIT = 'manual-edit',
  STATUS_AUTO_MAPPED = 'auto-mapped',
}

export type StatusProps = {
  status: STATUS_TYPES;
  title: string;
  showTooltip?: boolean;
  tooltip?: string;
};

export default function StatusBadge(props: StatusProps) {
  const { status, showTooltip, tooltip, title } = props;

  const isNoIconStatus =
    status === STATUS_TYPES.STATUS_MANUAL_EDIT ||
    status === STATUS_TYPES.STATUS_NEEDS_MAPPING ||
    status === STATUS_TYPES.STATUS_AUTO_MAPPED;

  const renderStatus = () => (
    <div className={`${CLASS_MAIN} ${showTooltip ? CLASSES.HELP_CURSOR : ''} ${CLASSES.ICON}-${status}`}>
      {!isNoIconStatus && <i className={`${CLASSES.ICON}`}></i>}
      {title}
    </div>
  );

  return title ? (
    showTooltip ? (
      <FlightTooltip description={tooltip} direction="bottom" isEnabled={showTooltip}>
        {renderStatus()}
      </FlightTooltip>
    ) : (
      renderStatus()
    )
  ) : (
    status
  );
}
